const getRandomInt = (max) => Math.floor(Math.random() * max)

export { getRandomInt }
